module.exports = __webpack_public_path__ + "static/media/last-eclipse.61ea5f05.png";